/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindCertificatesByOrganizationIdQueryResponse,
  FindCertificatesByOrganizationIdQueryParams,
} from "../types/FindCertificatesByOrganizationId.ts"

export const findCertificatesByOrganizationIdQueryKey = (
  params: FindCertificatesByOrganizationIdQueryParams
) =>
  [
    { url: "/v1/certificate/find-certificates-by-organization-id" },
    ...(params ? [params] : []),
  ] as const

export type FindCertificatesByOrganizationIdQueryKey = ReturnType<
  typeof findCertificatesByOrganizationIdQueryKey
>

/**
 * @summary Find certificates by organization id
 * {@link /v1/certificate/find-certificates-by-organization-id}
 */
export async function findCertificatesByOrganizationId(
  params: FindCertificatesByOrganizationIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCertificatesByOrganizationIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate/find-certificates-by-organization-id`,
    params,
    ...requestConfig,
  })
  return res
}

export function findCertificatesByOrganizationIdQueryOptions(
  params: FindCertificatesByOrganizationIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findCertificatesByOrganizationIdQueryKey(params)
  return queryOptions<
    ResponseConfig<FindCertificatesByOrganizationIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCertificatesByOrganizationIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return findCertificatesByOrganizationId(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find certificates by organization id
 * {@link /v1/certificate/find-certificates-by-organization-id}
 */
export function useFindCertificatesByOrganizationId<
  TData = ResponseConfig<FindCertificatesByOrganizationIdQueryResponse>,
  TQueryData = ResponseConfig<FindCertificatesByOrganizationIdQueryResponse>,
  TQueryKey extends QueryKey = FindCertificatesByOrganizationIdQueryKey,
>(
  params: FindCertificatesByOrganizationIdQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCertificatesByOrganizationIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findCertificatesByOrganizationIdQueryKey(params)

  const query = useQuery(
    {
      ...findCertificatesByOrganizationIdQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
